module.exports = __webpack_public_path__ + "img/train5.06376d7e.jpeg";